import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementZhCnLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhCnLocale from './zh-cn'

Vue.use(VueI18n)

const messages = {
  'zh-cn': {
    ...zhCnLocale,
    ...elementZhCnLocale
  }
}

const i18n = new VueI18n({
  locale: 'zh-cn',
  messages
})

export default i18n
